/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Choose_New_T1Inputs */

const en_plan_choose_new_t1 = /** @type {(inputs: Plan_Choose_New_T1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe idea`)
};

const id_plan_choose_new_t1 = /** @type {(inputs: Plan_Choose_New_T1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceritakan ide`)
};

/**
* | output |
* | --- |
* | "Describe idea" |
*
* @param {Plan_Choose_New_T1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const plan_choose_new_t1 = /** @type {((inputs?: Plan_Choose_New_T1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Choose_New_T1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_plan_choose_new_t1(inputs)
	return en_plan_choose_new_t1(inputs)
});